import React from 'react';
import { Main } from './components';

/**
 * Componente principal del módulo de Recepciones
 * Gestiona la recepción de mercancía en el almacén
 */
export const Receptions: React.FC = () => {
  return (
    <>
      <Main />
    </>
  );
};

export default Receptions;

